/**
 * Das Datum eines Hinweises kommt als ISO-Tag aus dem Backend (2026-10-28) und wird hier
 * fuer die Anzeige umgestellt. In der Antwort bleibt es maschinenlesbar, gelesen wird es
 * deutsch - und zwar an beiden Stellen gleich, Liste wie Vollansicht.
 */
export const alsDeutschesDatum = (isoTag: string): string => {
  const treffer = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoTag);
  // Was nicht wie ein ISO-Tag aussieht, bleibt unveraendert stehen: lieber ein roher Wert
  // als ein erfundener.
  if (!treffer) return isoTag;

  const [, jahr, monat, tag] = treffer;
  return `${tag}.${monat}.${jahr}`;
};

/**
 * Ein Zeitpunkt mit Uhrzeit, deutsch gelesen - fuer geplante Eintraege, bei denen der Tag
 * allein nicht reicht (KAN-276, A11). Steht hier neben `alsDeutschesDatum`, damit Liste und
 * Schreibmaske nicht zwei Schreibweisen entwickeln.
 */
export const alsZeitpunkt = (iso: string): string =>
  new Date(iso).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
